export const standardBrowser = {
  IE:      "Internet Explorer",
  Edge:    "Edge",
  Chrome:  "Chrome",
  Safari:  "Safari",
  Firefox: "Firefox",
}

const getBrowserInfo = () =>{
  var res = {
      name: "",
      version: "",
  };
  var reg;
  var userAgent = self.navigator.userAgent;

  if (reg = /edge\/([\d\.]+)/i.exec(userAgent)) {
      res.name = "Edge";
      res.version = reg[1];
  }
  else if (/msie/i.test(userAgent)) {
      res.name = "Internet Explorer";
      res.version = /msie ([\d\.]+)/i.exec(userAgent)[1];
  }
  else if (/Trident/i.test(userAgent)) {
      res.name = "Internet Explorer";
      res.version = /rv:([\d\.]+)/i.exec(userAgent)[1];
  }
  else if (/chrome/i.test(userAgent)) {
      res.name = "Chrome";
      res.version = /chrome\/([\d\.]+)/i.exec(userAgent)[1];
  }
  else if (/safari/i.test(userAgent)) {
      res.name = "Safari";
      res.version = /version\/([\d\.]+)/i.exec(userAgent)[1];
  }
  else if (/firefox/i.test(userAgent)) {
      res.name = "Firefox";
      res.version = /firefox\/([\d\.]+)/i.exec(userAgent)[1];
  }
  return res;
}


export const BrowserInfo = getBrowserInfo()

const Browser = standardBrowser
const browser = BrowserInfo.name

// 验证浏览器对扩展程序的支持， Only support Chrome/Edge/Firefox!
export const checkExtension = ()=> {
    return new Promise((resolve, reject)=> {
        if (browser === Browser.Chrome) {
            resolve(browser)
        } else if (browser === Browser.Edge || browser === Browser.Firefox) {
            if (document.getElementById(extensionName)) {
                resolve(browser)
            } else {
                reject({errorcode:1, result:'Extension does not exist!'})
            }
        } else {
            reject({errorcode:1, result:'Only support Chrome/Edge/Firefox!'})
        }
    })
}



// WEBPACK FOOTER //
// ./apps/cfca/cofco/const/browser.js